import { createContext, useState } from "react"
import API from "services/api"

export const LogRenewalContext = createContext({})

const LogRenewalProvider = (props) => {
	const [logrenewals, setLogRenewals] = useState([])

	const getLogRenewal = (params) => {
		return API.getLogRenewal(params)
			.then((res) => {
				const { data } = res
				setLogRenewals(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getLogRenbyParent = (id, params) => {
		return API.getLogRenbyParent(id, params)
			.then((res) => {
				const { data } = res
				setLogRenewals(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const postLogRenewal = (data) => {
		return API.postLogRenewal(data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	return (
		<LogRenewalContext.Provider
			value={{
				logrenewals,

				getLogRenewal,
				getLogRenbyParent,
				postLogRenewal
			}}
			{...props}
		/>
	)
}

export default LogRenewalProvider
